import script from "./FinanceCosts.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceCosts.vue?vue&type=script&setup=true&lang=js"

import "./FinanceCosts.vue?vue&type=style&index=0&id=3b4c4bca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b4c4bca"]])

export default __exports__